var exports = {
  "CR": "CustomStatusModal.module__modalRoot___RGdUSG",
  "_l": "CustomStatusModal.module__previewSection___RGdUSG",
  "uG": "CustomStatusModal.module__statusInputWrapper___RGdUSG",
  "Dq": "CustomStatusModal.module__characterCount___RGdUSG",
  "DY": "CustomStatusModal.module__emojiTriggerButton___RGdUSG",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___RGdUSG",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___RGdUSG",
  "J7": "CustomStatusModal.module__clearButtonIcon___RGdUSG",
  "qr": "CustomStatusModal.module__footer___RGdUSG",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___RGdUSG",
  "uD": "CustomStatusModal.module__expirationLabel___RGdUSG",
  "S2": "CustomStatusModal.module__expirationSelect___RGdUSG",
};

module.exports = exports;
